import {
  HeadContent,
  Outlet,
  Scripts,
  createRootRoute,
} from '@tanstack/react-router';

import { SiteFooter } from '@/components/layout/site-footer';
import { SiteHeader } from '@/components/layout/site-header';
import { staticPageHead } from '@/config/seo-head';
import { SITE_MAIN_ID, SITE_SKIP_LINK_LABEL } from '@/config/site';
import { fontHeadLinks } from '@/lib/fonts';

import '@/styles/globals.css';
import '@/styles/motion.css';

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ...staticPageHead('/').meta,
    ],
    links: [
      { rel: 'icon', href: '/favicon/icon.png' },
      { rel: 'apple-touch-icon', href: '/favicon/icon.png' },
      ...fontHeadLinks,
      ...(staticPageHead('/').links ?? []),
    ],
  }),
  component: RootDocument,
  notFoundComponent: NotFoundPage,
});

function RootDocument() {
  return (
    <html lang="en" data-scroll-behavior="smooth">
      <head>
        <HeadContent />
      </head>
      <body className="min-h-screen font-sans antialiased">
        <a
          href={`#${SITE_MAIN_ID}`}
          className="bg-brand text-primary-foreground focus:ring-ring sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:ring-2 focus:ring-offset-2"
        >
          {SITE_SKIP_LINK_LABEL}
        </a>

        <SiteHeader />

        <main
          id={SITE_MAIN_ID}
          tabIndex={-1}
          className="vt-main flex min-h-screen flex-col items-center outline-none"
        >
          <Outlet />
        </main>

        <SiteFooter />
        <Scripts />
      </body>
    </html>
  );
}

function NotFoundPage() {
  return (
    <div className="container max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-display-md text-ink font-bold">
        Page not found
      </h1>
      <p className="text-muted-foreground mt-4 text-base">
        That route does not exist yet. Try one of the destinations in the
        header.
      </p>
    </div>
  );
}
